import { Navigate, Outlet, useLocation } from 'react-router';
import { ErrorState, Skeleton } from '@/components/ui';
import { useSession } from '@/features/auth';
import { errorMessage } from '@/lib/errorMessage';

/** Session-only routes: page skeleton while loading (no spinner flash); guests go to `/?signin=1`. */
export function RequireSession() {
  const { status, error, retry } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div
        className="mx-auto flex w-full max-w-[1280px] flex-col gap-7 px-4 py-10 md:px-8 xl:px-20"
        aria-busy="true"
      >
        <Skeleton className="h-10 w-64" />
        <div className="grid gap-5 md:grid-cols-3">
          <Skeleton className="h-48 rounded-xl md:col-span-2" />
          <Skeleton className="h-48 rounded-xl" />
        </div>
      </div>
    );
  }
  if (status === 'error') {
    return (
      <div className="mx-auto w-full max-w-xl px-4 py-16">
        <ErrorState title="We couldn't load your account" message={errorMessage(error)} onRetry={retry} />
      </div>
    );
  }
  if (status === 'guest') {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/?signin=1&returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  return <Outlet />;
}
